// slider-pro.js

$(document).ready(function($) {
  $('#js_slider').sliderPro({
    width: '50%',
    aspectRatio: 1.5,
    visibleSize: '100%',
    forceSize: 'fullWidth',
    slideDistance: 0,
    autoplay: false,
    autoplayDelay: 5000,
    autoplayOnHover: 'pause',
    arrows: true,
    fadeArrows: true,
    buttons: false,
    smallSize: '320',
    mediumSize: '480',
    largeSize: '720',
    breakpoints: {
      640: {
        width: '100%',
      },
      800: {
        width: '75%',
      },
    },
  });
});

//
// EOF
//
